import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { BaseService } from '@library-shared/base/base.service';
import { Observable } from 'rxjs';
import { ApiRecordsReturn } from '@library-shared/models/api-records-return';
import { catchError } from 'rxjs/operators';
import { spAgency_List } from '@models-surebank/StoredProcs/spAgency_List';

@Injectable({
    providedIn: 'root',
})
export class AgencyService extends BaseService {
    private apiURL = environment.apiURL + '/api/agency'; // URL to web api

    Agency_List(): Observable<ApiRecordsReturn<spAgency_List>> {
        const url = `${this.apiURL}/Agency_List`;
        return this.http
            .post<ApiRecordsReturn<spAgency_List>>(url, {}, this.requestOptions)
            .pipe(catchError((e) => this.handleError(e)));
    }
}
